module.exports = __webpack_public_path__ + "static/media/datman.3bd47205.png";